import { brandInfo } from '@/mocks/content';
import Breadcrumb from '@/components/feature/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';

export default function AboutPage() {
  return (
    <>
      <PageSEO
        title="关于我们 - 海角最新地址"
        description="海角最新地址官方入口，提供海角最新地址实时更新服务。了解我们的品牌介绍、用户口碑与联系方式。海角最新地址入口、海角地址失效解决方案。"
        keywords="海角最新地址,海角官方地址,海角地址,关于海角"
        canonicalUrl="https://haijiao.readdy.ai/about"
      />

      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: '关于我们' },
        ]}
      />

      {/* Brand Introduction */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-4">
              关于我们
            </h1>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              了解海角最新地址的品牌故事与服务理念
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10 mb-12">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-building-4-line text-2xl text-primary-500"></i>
              </div>
              <div>
                <h2 className="font-heading text-xl text-foreground-900">品牌介绍</h2>
                <p className="text-sm text-foreground-500">{brandInfo.slogan}</p>
              </div>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed">
              {brandInfo.introduction}
            </p>
          </div>

          {/* Reputation */}
          <div className="mb-12">
            <div className="text-center mb-8">
              <h2 className="font-heading text-2xl text-foreground-900 mb-2">用户口碑</h2>
              <p className="text-sm text-foreground-500">来自真实用户的评价与反馈</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {brandInfo.reputation.map((item, index) => (
                <div key={index} className="bg-background-50 rounded-xl border border-background-200/70 p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-sm text-accent-500"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{item.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                      <i className="ri-user-line text-sm text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-900">{item.author}</p>
                      <p className="text-xs text-foreground-400">{item.date}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-2xl text-accent-600"></i>
              </div>
              <div>
                <h2 className="font-heading text-xl text-foreground-900">联系方式</h2>
                <p className="text-sm text-foreground-500">如有问题或建议，欢迎通过以下方式联系我们</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <div className="w-10 h-10 mx-auto rounded-lg bg-primary-100 flex items-center justify-center mb-3">
                  <i className="ri-mail-send-line text-lg text-primary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">{brandInfo.contact.email}</p>
              </div>
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <div className="w-10 h-10 mx-auto rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                  <i className="ri-wechat-line text-lg text-accent-600"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">微信</h3>
                <p className="text-xs text-foreground-500">{brandInfo.contact.wechat}</p>
              </div>
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <div className="w-10 h-10 mx-auto rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-qq-line text-lg text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">QQ</h3>
                <p className="text-xs text-foreground-500">{brandInfo.contact.qq}</p>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h3 className="font-heading text-lg text-foreground-900 mb-4">在线留言</h3>
              <form
                id="about-contact-form"
                data-readdy-form
                className="space-y-4"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);

                  const honeypot = formData.get('phone_alt') as string;
                  if (honeypot && honeypot.trim() !== '') {
                    alert('留言已提交，我们将尽快回复您！');
                    form.reset();
                    return;
                  }
                  formData.delete('phone_alt');

                  try {
                    const response = await fetch(
                      'https://readdy.ai/api/form/d9qr5qcnlsngrm4lm4g0',
                      {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                      }
                    );
                    const responseText = await response.text();
                    let parsed;
                    try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                    if (response.ok && parsed?.code === 'OK') {
                      alert('留言已提交，我们将尽快回复您！');
                      form.reset();
                    } else {
                      const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
                      alert(serverMsg || '提交失败，请稍后重试');
                    }
                  } catch {
                    alert('网络错误，请稍后重试');
                  }
                }}
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                  <input
                    type="text"
                    id="contact-subject"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
                    placeholder="请输入留言主题"
                  />
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                    placeholder="请输入您的留言内容（最多500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1">最多可输入500个字符</p>
                </div>
                <div className="spam-guard">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <button
                  type="submit"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  提交留言
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}